<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted } from 'vue';

import { useMapScaleLine } from '#nora-ui/map/composables/useMapScaleLine';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  mapId: string;
  minWidth?: number;
  maxWidth?: number;
}

const props = withDefaults(defineProps<Props>(), {
  minWidth: 70,
  maxWidth: 180,
});

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);

const scaleLine = useMapScaleLine({
  map,
  minWidth: props.minWidth,
  maxWidth: props.maxWidth,
});

const width = computed(() => scaleLine.width.value ?? 0);
const distanceText = computed(() => scaleLine.distanceText.value ?? '');

onMounted(async () => {
  await scaleLine.setup();
});
onBeforeUnmount(scaleLine.cleanup);
</script>

<template>
  <div class="pointer-events-none select-none flex flex-row items-end justify-end">
    <div
      class="text-xs font-semibold mr-2 text-primary-250"
      style="text-shadow: -1px -1px 0 var(--color-primary-850), 1px -1px 0 var(--color-primary-850), -1px 1px 0 var(--color-primary-850), 1px 1px 0 var(--color-primary-850), 0 0 2px var(--color-primary-850);"
    >
      {{ distanceText }}
    </div>
    <div
      class="bg-primary-250 border-primary-850 border relative h-1"
      :style="{ width: `${width}px` }"
    >
      <span class="border-primary-850 border border-b-0 absolute -left-px bottom-0.5 w-1 bg-primary-250 h-3" />
      <span class="border-primary-850 border border-b-0 absolute -right-px bottom-0.5 w-1 bg-primary-250 h-3" />
    </div>
  </div>
</template>
